import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-26d5257f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "head-back"
};
const _hoisted_3 = {
  class: "head-width"
};
const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "邀请记录", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head-width"
}, " ", -1));

const _hoisted_7 = {
  key: 0,
  class: "record-back"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "record-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "item-long item-title"
}, "邀请用户"), /*#__PURE__*/_createElementVNode("div", {
  class: "item-word item-title"
}, "注册资料日期"), /*#__PURE__*/_createElementVNode("div", {
  class: "item-short item-title"
}, "奖励")], -1));

const _hoisted_9 = {
  class: "item-long"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "name"
};
const _hoisted_12 = {
  class: "item-word"
};
const _hoisted_13 = {
  class: "item-short"
};
const _hoisted_14 = {
  key: 1,
  class: "empty"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_list = _resolveComponent("van-list");

  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $setup.Back,
    class: "back-head",
    onClick: _cache[0] || (_cache[0] = $event => $setup.router.back())
  }, null, 8, _hoisted_4)]), _hoisted_5, _hoisted_6]), $setup.list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createVNode(_component_van_pull_refresh, {
    modelValue: $setup.refreshing,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.refreshing = $event),
    onRefresh: $setup.onRefresh
  }, {
    default: _withCtx(() => [_createVNode(_component_van_list, {
      loading: $setup.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = $event => $setup.loading = $event),
      finished: $setup.finished,
      "finished-text": "没有更多了",
      onLoad: $setup.onLoad
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "record-item",
          key: index
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          src: item.avatar,
          class: "head-img"
        }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, _toDisplayString(item.nickname), 1)]), _createElementVNode("div", _hoisted_12, _toDisplayString($setup.curentTime(item.createTime)), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.sumMoney) + "元", 1)]);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])]),
    _: 1
  }, 8, ["modelValue", "onRefresh"])])) : (_openBlock(), _createElementBlock("div", _hoisted_14, " 暂无邀请记录 "))]);
}